import { TypedError } from './TypedError'

/**
 * 检查错误，可以被修复
 */
export abstract class LintError extends TypedError {}
